import { render, staticRenderFns } from "./OrderTravellerForm.vue?vue&type=template&id=4fedcdde&scoped=true"
import script from "./OrderTravellerForm.vue?vue&type=script&lang=js"
export * from "./OrderTravellerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fedcdde",
  null
  
)

export default component.exports